/** @griffel:css-start [d] null **/
.f22iagw{display:flex;}
.f1vx9l62{flex-direction:column;}
.f1noh358{row-gap:var(--spacingVerticalM);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f1ak2con{padding-block:20px;}
.f1akouvx{padding-inline:20px;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fxugw4r{background-color:var(--colorNeutralBackground1);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f1o0qvyv{border-radius:var(--borderRadiusLarge);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1whvlc6{box-shadow:var(--shadow4);}
.fi15kbk{border-block-start-width:var(--strokeWidthThin);}
.f10zy6vx{border-block-end-width:var(--strokeWidthThin);}
.f32hy0g{border-inline-start-width:var(--strokeWidthThin);}
.fgmlvap{border-inline-end-width:var(--strokeWidthThin);}
.f1taw3pw{border-block-start-style:solid;}
.f1p2dij1{border-block-end-style:solid;}
.fwyddsq{border-inline-start-style:solid;}
.fwl1lcr{border-inline-end-style:solid;}
.foi3q75{border-block-start-color:var(--colorNeutralStroke2);}
.f1a566p{border-block-end-color:var(--colorNeutralStroke2);}
.f1ftuoky{border-inline-start-color:var(--colorNeutralStroke2);}
.f1crbv9w{border-inline-end-color:var(--colorNeutralStroke2);}
.fni485r{flex-wrap:wrap;}
.f122n59{align-items:center;}
.f1869bpl{justify-content:space-between;}
.f1xcgk68{column-gap:var(--spacingHorizontalM);}
.f1wn3y0l{row-gap:var(--spacingVerticalS);}
.f778t4r{row-gap:var(--spacingVerticalXS);}
.fqerorx{flex-grow:1;}
.fuk1rnt{flex-basis:260px;}
.fuzgk9b{min-inline-size:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fod5ikn{font-size:var(--fontSizeBase400);}
.faaz57k{line-height:var(--lineHeightBase400);}
.fl43uef{font-weight:var(--fontWeightSemibold);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fo3dj2t{max-inline-size:72ch;}
.fkhj508{font-size:var(--fontSizeBase300);}
.f1i3iumi{line-height:var(--lineHeightBase300);}
.fkfq4zb{color:var(--colorNeutralForeground2);}
/** @griffel:css-end **/